import React, { useState } from 'react'
import axios from 'axios';
import firebase from 'firebase/app';
import { isLoaded  } from 'react-redux-firebase';
import { Position,  Intent, Toaster } from "@blueprintjs/core";
import Checkout from '../../stripe/Checkout';



const AppToaster = Toaster.create({
    className: "copied-content",
    position: Position.TOP,
});

const showToast = () => {
    AppToaster.show({ message: "JWT Copied", intent: Intent.SUCCESS, timeout: 1000});
}

function MainDeveloper({
    developers,
    auth
}) {

    const [ tokensBought, setTokensBought ] = useState(0)
    const [ cost, setCost ] = useState (0)
    // console.log(tokensBought)
    
    const getKey = () =>{
        axios.post("https://boundapiv2.herokuapp.com/jwt")
        .then((res) =>{
            console.log(res)
            let jwt = res.data

            firebase.firestore().collection('developers').doc(jwt).set({
                JWT: jwt,
                tokens: 10,
                auth: auth.uid
            })
        })
    }

    const copyJWT = () =>{
        var textField= document.createElement('textarea')
        textField.innerHTML=developers[0].JWT
        document.body.appendChild(textField)
        textField.select()
        document.execCommand('copy')
        textField.remove()
        showToast()
    }

    const setTokens = (e) =>{
        setTokensBought(e)
        let charge = e * .2
        let str = charge.toString()
        let slice = str.slice(0, (str.indexOf(".")) +3)
        let finalCharge = Number(slice)
        setCost(finalCharge)
    }

    if (!isLoaded(developers)) return( 
        <div>

        </div>
        )

    return (
        <div>
            <div className="bg-white rounded-lg shadow-md w-full">
                {/* Can only click this once and state will disapper, needs to be on users */}
                <div className="mb-4 border-b-2 border-gray-200 w-full p-4 text-xl font-medium">
                    JWT Token
                </div>
                {developers?.length > 0 ? 
                <div className='flex p-4 pt-1'>
                    <div className="p-3 overflow-auto break-words w-1/2 border-gray-400 border-2 rounded-lg">
                        {developers?.[0]?.JWT}
                    </div>
                    <div className="ml-4">
                        <button 
                            className= "p-2 font-semibold text-white bg-green-600 hover:bg-green-400 rounded-md"
                            onClick={copyJWT}    
                        >
                            Copy Token
                        </button>
                    </div>
                </div>
                :
                <div className="p-4">
                <button 
                    className="p-2 rounded-lg bg-green-600 text-white hover:bg-green-500 font-semibold focus:outline-none"
                    onClick={getKey} 
                >
                    Get API Key
                </button>
                </div>
                }
            </div>
            <div className="bg-white rounded-lg shadow-md w-full p-4 my-3">
                <div className="text-2xl font-medium mb-4">
                    Billing
                </div>
                <div className="text-lg mb-4">
                    Tokens Available: {developers?.length > 0 ? developers[0].tokens : 0}
                </div>
                <div className="my-4 p-1 border-2 border-gray-200 rounded-md w-1/2">
                    <input 
                    className="w-full focus:outline-none focus-ring"
                    placeholder="Buy Tokens"
                    type="number"
                    onChange={(e) => setTokens(e.target.value)}
                    />
                </div>
                <div className="mb-4">
                    Cost: ${cost}
                </div>
                <button 
                    className="p-2 rounded-lg bg-blue-600 text-white hover:bg-blue-500 font-semibold focus:outline-none disabled:opacity-50"
                    // onClick={getKey}
                    disabled={tokensBought < 1 ? true : false}    
                >
                    Buy More Tokens
                </button>
                <Checkout 
                auth={auth}
                developers={developers}
                cost={cost}
                tokensBought={tokensBought}
                />
            </div>
        </div>
    )
}

export default MainDeveloper
